import { BADGE_COLOR_MAP, DEFAULT_BADGE_COLOR } from '@/constants';

export const getBadgeColor = (upperCode: string) =>
  BADGE_COLOR_MAP[upperCode] || DEFAULT_BADGE_COLOR;
